import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { APPLICATION_ID, CFC_IDS } from '../../../constants';

import { fetchContactRequestReasonIfNeeded } from '../../../services/contactrequest/actions';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import ContactRequestFormComponent from './ContactRequestFormComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import { ContactRequestMainContainer } from './ContactRequestFormComponentStyle';

export class ContactRequestPage extends React.Component {
    componentDidMount() {
        this.props.fetchContactRequestReasonIfNeeded();
    }

    render() {
        const { i18n } = this.props;

        return (
            <ContactRequestMainContainer
                id="p-contactrequest"
                className="conteneur conteneur-mobile">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.CONTACTREQUEST_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>

                {CFC_IDS.includes(APPLICATION_ID) && (
                    <p className="delay-message">{i18n.AVERAGE_PROCCESSING_TIME}</p>
                )}

                <ContactRequestFormComponent />
            </ContactRequestMainContainer>
        );
    }
}

ContactRequestPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.CONTACTREQUEST
    };
};

const mapDispatchToProps = {
    fetchContactRequestReasonIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(ContactRequestPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/contactrequest/ContactRequestPage.js